import { MaterialTableColumnProps } from '@/components/material-table/material-table';

export const textOptions = [
  { label: 'Heading 1', value: 'heading' },
  { label: 'Heading 2', value: 'heading-2' },
  { label: 'Heading 3', value: 'heading-3' },
  { label: 'Heading 4', value: 'heading-4' },
  { label: 'Body', value: 'text' },
  { label: 'Text Block', value: 'text-block' },
]

export const emailColumns:MaterialTableColumnProps[] = [
  {
    header: 'ID',
    accessorKey: '_id',
    visible: true,
    type: 'string'
  },
  {
    header: 'Date',
    accessorKey: 'created_at',
    visible: true,
    type: 'date'
  },
  {
    header: 'Subject',
    accessorKey: 'subject',
    visible: true,
    type: 'string'
  },
]